import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetClientState, getClient } from "../../../store/client/action";
import { resetBranchState, getBranch } from "../../../store/branch/action";
import { getLegalPeil as onGetLegalPeils, addNewLegalPeil as onAddNewLegalPeil, updateLegalPeil as onUpdateLegalPeil, deleteLegalPeil as onDeleteLegalPeil, getLegalPeilLoading } from "../../../store/legalPeil/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import ExportDoc from "../../../Components/Common/ExportDoc";

const LegalPeil = () => {
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [pageIdx, setPageIdx] = useState(0);
  const dispatch = useDispatch();

  const { branches, branchLoading, positions, assetCategories, isLegalPeilCreated, isLegalPeilSuccess, loading, error, brands, brandLoading, companies, companyLoading, clientLoading, clients } = useSelector((state) => ({
    assetCategories: state.LegalPeil.assetCategories,
    isLegalPeilCreated: state.LegalPeil.isLegalPeilCreated,
    isLegalPeilSuccess: state.LegalPeil.isLegalPeilSuccess,
    loading: state.LegalPeil.loading,
    brands: state.Brand.brands,
    brandLoading: state.Brand.loading,
    error: state.LegalPeil.error,
    positions: state.Position.positions,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
  }));

  const [legalPeilList, setLegalPeilList] = useState([]);
  const [legalPeilDoc, setLegalPeilDoc] = useState([]);
  const [legalPeil, setLegalPeil] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [parentList, setParentList] = useState([]);
  const [branchList, setBranchList] = useState([]);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [positionList, setPositionList] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [legalPeilFiles, setLegalPeilFiles] = useState([]);
  const [originalFiles, setOriginalFiles] = useState([]);
  const [logo, setLogo] = useState(defaultImg);

  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  useEffect(() => {
    if (!isSearch) {
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method && obj?.data?.user?.user_position?.position_role.method);
        setUserData(obj.data);
        setUserType(obj?.data?.userType);
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
        setPositionMessage(`${obj?.data?.user?.user_department && obj?.data?.user?.user_department?.name}, ${obj?.data?.user?.user_position && obj?.data?.user?.user_position?.name}`);
        setClientSelect({
          label: obj.data.client_name,
          value: obj.data.clientId,
        });
        setCompanySelect({
          label: obj.data.company_name,
          value: obj.data.companyId,
        });

        dispatch(onGetLegalPeils());
        dispatch(resetClientState());
        dispatch(getClient());
        handleGetCompany(obj.data.clientId);
        handleGetBranch(obj.data.companyId);
      }
    }
  }, [dispatch, isSearch]);

  const onClickDelete = (legalPeil) => {
    setLegalPeil(legalPeil);
    setDeleteModal(true);
  };

  const handleDeleteLegalPeil = () => {
    if (legalPeil) {
      dispatch(onDeleteLegalPeil(legalPeil));
      setDeleteModal(false);
    }
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = legalPeilFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setLegalPeilFiles(newState);
    } else {
      const index = legalPeilFiles.findIndex((fl) => fl.filename === file.filename);

      setLegalPeilFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  useEffect(() => {
    if (!isEmpty(legalPeilList)) {
      let arr = [];
      legalPeilList.forEach((asset) => {
        arr.push({ value: asset.id, label: asset.name });
      });
    }
  }, [legalPeilList]);

  useEffect(() => {
    setPositionList(positions);
  }, [positions]);

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!isEmpty(assetCategories)) setLegalPeilList(assetCategories.map((el) => ({ ...el, isChecked: false })));
  }, [assetCategories]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
      {
        id: "legal_peil_client",
        label: "Grup Usaha",
        isSelected: true,
        data: [],
      },
      {
        id: "legal_peil_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
    ];

    if (legalPeilList.length > 0) {
      legalPeilList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "par_legal_peil" || doc.id === "legal_peil_client" || doc.id === "legal_peil_company") {
                doc.data.push(value?.name ?? "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setLegalPeilDoc(dataDoc);
  }, [legalPeilList]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredLegalPeils = assetCategories;
      if (type !== "all") {
        filteredLegalPeils = assetCategories.filter((legalPeil) => {
          return legalPeil.legal_peil_status && legalPeil.legal_peil_status.name === type;
        });
      }
      setLegalPeilList(filteredLegalPeils);
    }
  };

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  useEffect(() => {
    setLegalPeil(assetCategories);
  }, [assetCategories]);

  useEffect(() => {
    if (!isEmpty(assetCategories)) {
      setLegalPeil(assetCategories);
      setIsEdit(false);
    }
  }, [assetCategories]);

  // useEffect(() => {
  //   if (!isEmpty(assetCategories)) {
  //     setLegalPeilList(assetCategories);
  //   }
  // }, [assetCategories]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(assetCategories)) {
      var data = [];
      var opt = [];
      assetCategories.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setParentList(data);
    }
  }, [assetCategories]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (branches.length > 0) {
      setBranchList(data);
    }
  }, [branches]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setLegalPeil(null);
      setLegalPeilFiles([]);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleLegalPeilClick = useCallback(
    (arg) => {
      const legalPeil = arg;
      setLegalPeil({
        id: legalPeil.id,
        client: {
          label: legalPeil.legal_peil_client.name,
          value: legalPeil.legal_peil_client.id,
        },
        company: {
          label: legalPeil.legal_peil_company.name,
          value: legalPeil.legal_peil_company.id,
        },
        branch: legalPeil.legal_peil_branch
          ? {
              label: legalPeil.legal_peil_branch.name,
              value: legalPeil.legal_peil_branch.id,
            }
          : "",
        nama: legalPeil.nama,
        perusahaan: legalPeil.perusahaan,
        jabatan: legalPeil.jabatan,
        alamat: legalPeil.alamat,
        ruas_jalan: legalPeil.ruas_jalan,
        desa: legalPeil.desa,
        kecamatan: legalPeil.kecamatan,
        luas_tanah: legalPeil.luas_tanah,
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      client: (legalPeil && legalPeil.client) || clientSelected,
      company: (legalPeil && legalPeil.company) || companySelected,
      branch: (legalPeil && legalPeil.branch) ?? "",
      nama: (legalPeil && legalPeil.nama) ?? "",
      perusahaan: (legalPeil && legalPeil.perusahaan) ?? "",
      jabatan: (legalPeil && legalPeil.jabatan) ?? "",
      alamat: (legalPeil && legalPeil.alamat) ?? "",
      ruas_jalan: (legalPeil && legalPeil.ruas_jalan) ?? "",
      desa: (legalPeil && legalPeil.desa) ?? "",
      kecamatan: (legalPeil && legalPeil.kecamatan) ?? "",
      luas_tanah: (legalPeil && legalPeil.luas_tanah) ?? "",
    },
    validationSchema: Yup.object({
      nama: Yup.string().required("Please enter nama"),
    }),
    onSubmit: (values) => {
      dispatch(getLegalPeilLoading());
      if (isEdit) {
        const updateLegalPeil = {
          id: legalPeil ? legalPeil.id : 0,
          clientId: values.client.value,
          companyId: values.company.value,
          branchId: values.branch.value,
          nama: values.nama,
          perusahaan: values.perusahaan,
          jabatan: values.jabatan,
          alamat: values.alamat,
          ruas_jalan: values.ruas_jalan,
          desa: values.desa,
          kecamatan: values.kecamatan,
          luas_tanah: values.luas_tanah,
        };
        dispatch(onUpdateLegalPeil(updateLegalPeil));
        validation.resetForm();
      } else {
        const newLegalPeil = {
          clientId: values.client.value,
          companyId: values.company.value,
          branchId: values.branch.value,
          nama: values.nama,
          perusahaan: values.perusahaan,
          jabatan: values.jabatan,
          alamat: values.alamat,
          ruas_jalan: values.ruas_jalan,
          desa: values.desa,
          kecamatan: values.kecamatan,
          luas_tanah: values.luas_tanah,
        };
        dispatch(onAddNewLegalPeil(newLegalPeil));
        validation.resetForm();
      }
      toggle();
    },
  });

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteLegalPeil(element.value));
    });
    checkall.checked = false;
  };

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = legalPeilList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setLegalPeilList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        filterable: false,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = legalPeilList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setLegalPeilList(updatedData);
                }} />
            </div>
          );
        },
      },
      {
        Header: " ",
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <Link
                to="#"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-icon btn btn-sm btn-light edit-item-btn" : userRole && userRole.split(",").indexOf("updateLegalPeil") !== -1 ? "btn-icon btn btn-sm btn-light edit-item-btn" : "btn-icon btn btn-sm btn-light edit-item-btn d-none"}
                onClick={() => {
                  const legalPeilData = cellProps.row.original;
                  handleLegalPeilClick(legalPeilData);
                }}>
                <i className="ri-edit-2-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : userRole && userRole.split(",").indexOf("deleteLegalPeil") !== -1 ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"}
                onClick={() => {
                  const legalPeilData = cellProps.row.original;
                  onClickDelete(legalPeilData);
                }}>
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Link>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Grup Usaha",
        accessor: "legal_peil_client.name",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "legal_peil_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          }
        },
      },
    ],
    [legalPeilList, handleLegalPeilClick, userRole, userType, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = legalPeilList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setLegalPeilList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => legalPeilList, [legalPeilList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleLegalPeilStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetLegalPeils(param));
  }

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetBranch = (companyId) => {
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: companyId }));
  };

  document.title = "Legal Peil | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={legalPeilList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteLegalPeil} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Legal Peil" pageTitle="Perizinan" />
        <Row>
          <Col lg={12}>
            <Card id="legalPeilList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Data Legal Peil &nbsp;
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createLegalPeil") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
                      id="create-btn"
                      onClick={() => {
                        setLegalPeil("");
                        setIsEdit(false);
                        setCompanyList([]);
                        toggle();
                      }}>
                      <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
                    </button>
                    <ExportDoc data={legalPeilDoc} />
                    <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn ms-1 btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteLegalPeil") !== -1 ? "btn ms-1 btn-soft-danger" : "btn ms-1 btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#">
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> ALL CATEGORY
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#">
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={8}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                            gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}/>
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}>
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}>
                          {" "}
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Legal Peil" : "Tambah Legal Peil"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                setBranchList([]);
                                validation.resetForm();
                                validation.setFieldValue("company", e);
                                handleGetBranch(e.value);
                              }}
                              options={companyList}></Select>
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="branch-field" className="form-label">
                              Branch&nbsp;
                              {branchLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="branch"
                              value={validation.values.branch}
                              placeholder="Select Branch"
                              onChange={(e) => {
                                validation.setFieldValue("branch", e);
                              }}
                              options={branchList}></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="nama-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="nama" id="nama-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.nama} invalid={validation.touched.nama && validation.errors.nama ? true : false} />
                            {validation.touched.nama && validation.errors.nama ? <FormFeedback type="invalid">{validation.errors.nama}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="perusahaan-field" className="form-label">
                              Perusahaan
                            </Label>
                            <Input name="perusahaan" id="perusahaan-field" className="form-control" placeholder="Isi Perusahaan" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.perusahaan} invalid={validation.touched.perusahaan && validation.errors.perusahaan ? true : false} />
                            {validation.touched.perusahaan && validation.errors.perusahaan ? <FormFeedback type="invalid">{validation.errors.perusahaan}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="jabatan-field" className="form-label">
                              Jabatan
                            </Label>
                            <Input name="jabatan" id="jabatan-field" className="form-control" placeholder="Isi Jabatan" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.jabatan} invalid={validation.touched.jabatan && validation.errors.jabatan ? true : false} />
                            {validation.touched.jabatan && validation.errors.jabatan ? <FormFeedback type="invalid">{validation.errors.jabatan}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          {" "}
                          <div className="mb-3">
                            <Label htmlFor="alamat-field" className="form-label">
                              Alamat
                            </Label>
                            <Input name="alamat" id="alamat-field" className="form-control" placeholder="Isi Alamat" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.alamat} invalid={validation.touched.alamat && validation.errors.alamat ? true : false} />
                            {validation.touched.alamat && validation.errors.alamat ? <FormFeedback type="invalid">{validation.errors.alamat}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="ruas_jalan-field" className="form-label">
                              Ruas Jalan
                            </Label>
                            <Input name="ruas_jalan" id="ruas_jalan-field" className="form-control" placeholder="Isi Ruas Jalan" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.ruas_jalan} invalid={validation.touched.ruas_jalan && validation.errors.ruas_jalan ? true : false} />
                            {validation.touched.ruas_jalan && validation.errors.ruas_jalan ? <FormFeedback type="invalid">{validation.errors.ruas_jalan}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="desa-field" className="form-label">
                              Desa
                            </Label>
                            <Input name="desa" id="desa-field" className="form-control" placeholder="Isi Desa" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.desa} invalid={validation.touched.desa && validation.errors.desa ? true : false} />
                            {validation.touched.desa && validation.errors.desa ? <FormFeedback type="invalid">{validation.errors.desa}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="kecamatan-field" className="form-label">
                              Kecamatan
                            </Label>
                            <Input name="kecamatan" id="kecamatan-field" className="form-control" placeholder="Isi Kecamatan" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.kecamatan} invalid={validation.touched.kecamatan && validation.errors.kecamatan ? true : false} />
                            {validation.touched.kecamatan && validation.errors.kecamatan ? <FormFeedback type="invalid">{validation.errors.kecamatan}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="luas_tanah-field" className="form-label">
                              Luas Tanah
                            </Label>
                            <Input name="luas_tanah" id="luas_tanah-field" className="form-control" placeholder="Isi Luas Tanah" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.luas_tanah} invalid={validation.touched.luas_tanah && validation.errors.luas_tanah ? true : false} />
                            {validation.touched.luas_tanah && validation.errors.luas_tanah ? <FormFeedback type="invalid">{validation.errors.luas_tanah}</FormFeedback> : null}
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                            setCompanyList([]);
                          }}>
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Tambah Legal Peil"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LegalPeil;
